import type { CompsMeasuresCssFeature } from './compsMeasuresCss.types'
import { compsMeasuresCssDomApplier } from './compsMeasuresCssDomApplier'
import { compsMeasures } from './compsMeasuresCssCompNode'
import { autoHeightWrapper } from '../autoHeightWrapper/autoHeightWrapperCompNode'
import { CssFeatureSymbol } from '../../ioc/catharsis-ioc'
import type { BindFeature } from '@wix/thunderbolt-catharsis-ioc'
import { compInfoNodes } from '@wix/thunderbolt-component-isolation'

export const compsMeasuresCssFeature: CompsMeasuresCssFeature = {
	featureName: 'compsMeasuresCss',
	experimentName: 'OPEN_TO_ALL',
	renderableNodes: { compsMeasures: compsMeasures(false) },
	intermediateNodes: {
		hasResponsiveLayout: compInfoNodes.hasResponsiveLayout,
	},
	dataMaps: ['component_properties', 'document_data', 'layout_data'],
	domApplier: compsMeasuresCssDomApplier,
}

export const editorCompsMeasuresCssFeature: CompsMeasuresCssFeature = {
	...compsMeasuresCssFeature,
	renderableNodes: { compsMeasures: compsMeasures(true), autoHeightWrapper },
}

export const page: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(compsMeasuresCssFeature)
}

export const editor: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(editorCompsMeasuresCssFeature)
}
